export default __webpack_public_path__ + "static/media/EI.8841dbb2.png";